import React from 'react';
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        const { error } = this.state;
        if (error) {
            return (React.createElement("div", null,
                React.createElement("h1", null, "Ooops... error found :("),
                React.createElement("pre", null, error.message)));
        }
        const { children } = this.props;
        return children;
    }
}
